import { render } from "./CustomerRegister.vue?vue&type=template&id=4f812be2"
import script from "./CustomerRegister.vue?vue&type=script&lang=js"
export * from "./CustomerRegister.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__